import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useUserQuery } from "../graphql/menu.hooks";

export function useIsNoShared() {
  const { projectId } = useParams<{ projectId: string }>();
  const { data: user } = useUserQuery();

  return useMemo(() => {
    if (!user || !user.user || !projectId) return false;
    return user.user.domains.some((domain) => +domain.id === +projectId);
  }, [user, projectId]);
}
